(function () {
  var stockContainer = document.getElementById('gdl-drop-stock');
  if (!stockContainer) return;

  var fillEl = stockContainer.querySelector('.gdl-drop-stock__fill');
  var countEl = stockContainer.querySelector('.gdl-drop-stock__count');
  var totalEl = stockContainer.querySelector('.gdl-drop-stock__total');
  var titleEl = stockContainer.querySelector('.gdl-drop-stock__title');
  var soldEl = stockContainer.querySelector('.gdl-drop-stock__sold');
  var warningEl = document.getElementById('gdl-drop-warning');

  var totalGrams = parseInt(stockContainer.dataset.totalGrams, 10) || 1000;
  var remainingGrams = parseInt(stockContainer.dataset.remainingGrams, 10) || 0;
  // Unit labels: grams by default, or units (e.g. " box restantes") when the drop counts items
  var unitRest = stockContainer.dataset.unitRest || 'g restants';
  var unitTotal = stockContainer.dataset.unitTotal || 'g';

  var countAnimId = null;

  // --- Urgency level ---
  // normal:   0-10% vendu (90-100% restant) → green
  // medium:   10-40% vendu (60-90% restant) → orange
  // critical: 40%+ vendu (<60% restant)     → red

  function getUrgency(percent) {
    if (percent >= 90) return 'normal';
    if (percent >= 60) return 'medium';
    return 'critical';
  }

  function getUrgencyText(percent) {
    if (percent >= 90) return 'En stock \u2014 Disponible';
    if (percent >= 60) return 'Stock limit\u00e9 \u2014 \u00c7a part vite';
    return '\uD83D\uDD25 Stock critique \u2014 Derni\u00e8res quantit\u00e9s';
  }

  // --- Count animation ---

  function animateCount(from, to, duration) {
    if (countAnimId) cancelAnimationFrame(countAnimId);
    var start = Date.now();
    var diff = to - from;

    countEl.classList.add('gdl-counting');

    function tick() {
      var elapsed = Date.now() - start;
      var progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(from + diff * eased);
      countEl.textContent = current + unitRest;

      if (progress < 1) {
        countAnimId = requestAnimationFrame(tick);
      } else {
        countEl.textContent = to + unitRest;
        countEl.classList.remove('gdl-counting');
        countEl.classList.add('gdl-count-settle');
        setTimeout(function () {
          countEl.classList.remove('gdl-count-settle');
        }, 350);
        countAnimId = null;
      }
    }

    countAnimId = requestAnimationFrame(tick);
  }

  // --- Stock bar update ---

  function updateBar(grams, animate) {
    var prevGrams = remainingGrams;
    remainingGrams = Math.max(0, grams);
    var percent = Math.min(100, (remainingGrams / totalGrams) * 100);
    var soldPercent = Math.round(100 - percent);

    fillEl.style.width = percent + '%';
    totalEl.textContent = '/ ' + totalGrams + unitTotal;
    soldEl.textContent = soldPercent + '% vendu';
    var urgency = getUrgency(percent);
    stockContainer.dataset.urgency = urgency;

    // Update title text only (keep the dot span)
    var titleTextNode = titleEl.lastChild;
    if (titleTextNode && titleTextNode.nodeType === 3) {
      titleTextNode.textContent = getUrgencyText(percent);
    } else {
      titleEl.textContent = getUrgencyText(percent);
    }

    // Count animation or instant
    if (animate && prevGrams !== remainingGrams) {
      animateCount(prevGrams, remainingGrams, 700);
    } else {
      countEl.textContent = remainingGrams + unitRest;
    }

    if (warningEl) {
      var selectedVariant = document.querySelector('.variant-button.selected, .variant-button[aria-pressed="true"]');
      var selectedGram = selectedVariant ? parseInt(selectedVariant.dataset.variantGram, 10) || 0 : 0;
      if (selectedGram >= 50 && remainingGrams < 200) {
        warningEl.classList.add('gdl-drop-warning--visible');
      } else {
        warningEl.classList.remove('gdl-drop-warning--visible');
      }
    }
  }

  // Initial render
  updateBar(remainingGrams, false);

  // Update warning on variant change
  var variantGrid = document.getElementById('variant-grid');
  if (variantGrid) {
    variantGrid.addEventListener('click', function () {
      setTimeout(function () { updateBar(remainingGrams, false); }, 50);
    });
  }

  // --- Polling via Section Rendering API ---

  var sectionId = stockContainer.dataset.sectionId;
  var productUrl = stockContainer.dataset.productUrl;

  if (productUrl && sectionId) {
    setInterval(function () {
      var url = productUrl + '?sections=' + encodeURIComponent(sectionId) + '&_t=' + Date.now();
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remote = doc.getElementById('gdl-drop-stock');
          if (remote) {
            var newRemaining = parseInt(remote.dataset.remainingGrams, 10);
            if (!isNaN(newRemaining) && newRemaining !== remainingGrams) {
              updateBar(newRemaining, true);
            }
          }

          // Update variant availability from fresh server data
          var remoteButtons = doc.querySelectorAll('#variant-grid .variant-button');
          var allDisabled = true;
          remoteButtons.forEach(function (remoteBtn) {
            var vid = remoteBtn.dataset.variantId;
            var isDisabled = remoteBtn.hasAttribute('disabled');
            var localBtn = document.querySelector('#variant-grid .variant-button[data-variant-id="' + vid + '"]');
            if (!localBtn) return;
            if (isDisabled) {
              localBtn.setAttribute('disabled', '');
            } else {
              localBtn.removeAttribute('disabled');
              allDisabled = false;
            }
          });

          // Sold out: all variants disabled or nothing remaining (single-variant drops have no buttons, so only the stock counts)
          if (((remoteButtons.length > 0 && allDisabled) || remainingGrams <= 0) && typeof window.setSoldOut === 'function') {
            window.setSoldOut();
          }
        })
        .catch(function () {});
    }, 15000);
  }
})();
